import {
  MERGE_FROM_DEVICE_REQUEST,
  MERGE_FROM_DEVICE_SUCCESS,
  MERGE_FROM_DEVICE_FAILURE,
  DELETE_ALL_SYNC_SONGS_REQUEST,
  DELETE_ALL_SYNC_SONGS_SUCCESS,
  DELETE_ALL_SYNC_SONGS_FAILURE
} from '../types/syncTypes';

const initialState = {
  mergeLoading: false,
  mergeData: null,
  mergeError: null,
  deleteLoading: false,
  deleteData: null,
  deleteError: null
};

const syncReducer = (state = initialState, action) => {
  switch (action.type) {
    case MERGE_FROM_DEVICE_REQUEST:
      return {
        ...state,
        mergeLoading: true,
        mergeError: null
      };
    case MERGE_FROM_DEVICE_SUCCESS:
      return {
        ...state,
        mergeLoading: false,
        mergeData: action.payload,
        mergeError: null
      };
    case MERGE_FROM_DEVICE_FAILURE:
      return {
        ...state,
        mergeLoading: false,
        mergeError: action.payload,
        mergeData: null
      };
    case DELETE_ALL_SYNC_SONGS_REQUEST:
      return {
        ...state,
        deleteLoading: true,
        deleteError: null
      };
    case DELETE_ALL_SYNC_SONGS_SUCCESS:
      return {
        ...state,
        deleteLoading: false,
        deleteData: action.payload,
        deleteError: null
      };
    case DELETE_ALL_SYNC_SONGS_FAILURE:
      return {
        ...state,
        deleteLoading: false,
        deleteError: action.payload,
        deleteData: null
      };
    default:
      return state;
  }
};

export default syncReducer;
